<template>
  <div class="selectbox" :id="rand">
    <div class="title" :class="{open: open || model}">
      {{ data.label || '' }}
    </div>
    <div class="label" @click="open = !open">
      {{ model ? model.name : open ? 'Выберите значение' : '' }}
    </div>
    <div class="options animate__animated animate__fadeInUp animate__faster" v-if="open">
      <div class="option" v-for="(option, i) in items" :key="i" @click="setOption(option)" :class="{active: model && (model.value === option.value)}">
        {{ option.name }}
      </div>
    </div>
    <ChevronDownIcon class="icon" />
  </div>
</template>

<script>
import ChevronDownIcon from '@/assets/svg/chevron-down-icon.svg?inline'

export default {
  components: {
    ChevronDownIcon
  },
  props: {
    data: Object,
    all: Object
  },
  data () {
    return {
      items: [],
      model: null,
      open: false,
      rand: null
    }
  },
  methods: {
    setOption (option) {
      if (this.model) {
        if (this.model.value !== option.value) {
          this.model = option.value === 0 ? null : option
          this.$emit('set', this.model)
        }
      } else {
        this.model = option.value === 0 ? null : option
        this.$emit('set', this.model)
      }
      this.open = false
    }
  },
  mounted () {
    this.items = this.data.items.filter(item => {
      return item
    })
    this.model = this.data.value || null
    if (this.data.special) {
      this.items.push(this.data.specialDefault)
      if (this.all[this.data.specialKey].value) {
        this.model = this.data.specialDefault
      }
    }
    this.rand = 'selectbox_' + Math.floor(Math.random() * (9999999999 - 1000000000) + 1000000000)
    window.addEventListener('click', (e) => {
      if (!e.target.closest(`#${this.rand}`)) {
        this.open = false
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.selectbox{
  @include box(100%, 3.5vw, relative, 0, 0, null, null, 0, null);
  @include flex(center, center, column);
  @include padding(0, 1vw, 0, 0);
  .title{
    @include box(100%, 2.5vw, absolute, 0, 1vw, null, null, 0, null);
    @include text(0.85vw, 400, null, null, left, $inputLabel);
    @include flex(left, center, row);
    &.open{
      @include box(null, null, absolute, 0, -0.5vw, null, null, null, null);
      @include text(0.7vw, null, null, null, null, $inputColorActive);
    }
  }
  .label{
    @include box(100%, 2.5vw, relative, 0, 0, null, null, 0, $input);
    @include border(null, solid, $inputBorder, null, null, null, 0.06vw);
    @include text(0.8vw, 400, null, null, left, $inputColor);
    @include flex(left, center, row);
    z-index: 2;
    cursor: pointer;
    text-transform: capitalize;
  }
  .icon{
    @include box(2vw, 2vw, absolute, null, null, 0, null, null, null);
    cursor: pointer;
    z-index: 2;
    transition: 0.3s;
    fill: $inputPasswordIcon;
  }
  .options{
    @include box(100%, auto, absolute, 0, calc(100% + 0.5vw), null, null, 0.3vw, $selectOptions);
    @include flex(left, top, column);
    @include border(0.04vw, solid, $selectOptionsBorder, null, null, null, 0.06vw);
    box-shadow: $selectOptionsShadow;
    overflow: hidden;
    z-index: 99;
    .option{
      @include box(100%, null, relative, null, null, null, null, null, null);
      @include flex(left, center, row);
      @include padding(1vw, 0.8vw, 1vw, 0.8vw);
      @include text(0.8vw, 400, null, null, left, $selectOptionColor);
      text-transform: capitalize;
      &:hover{
        @include box(100%, null, relative, null, null, null, null, null, $selectOptionHover);
        @include text(null, null, null, null, null, $selectOptionColorHover);
        cursor: pointer;
      }
      &.active{
        @include box(100%, null, relative, null, null, null, null, null, $selectOptionHoverActive);
        @include text(null, null, null, null, null, $selectOptionColorHover);
        cursor: default;
      }
    }
  }
}
</style>
